import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: 'calc(100% - 16px)', sm: '92%', md: '85%', lg: '80%' },
  maxWidth: 960,
  maxHeight: { xs: '96vh', sm: '92vh' },
  overflowY: 'auto',
  bgcolor: 'background.paper',
  borderRadius: { xs: 2, sm: 2 },
  boxShadow: 24,
  p: { xs: 1, sm: 2, md: 3 },
};

export default function CustomModal({ content, open, setOpen }) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: { xs: 0, sm: 0.5 } }}>
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        {content}
      </Box>
    </Modal>
  );
}
